<div class="modal-container">
  <div class="modal">
    <h2 class="modal-heading">Principal Attestation Requirement</h2>
    <div mat-dialog-content>
      <mat-checkbox
        [labelPosition]="'after'"
        [disabled]="!data.mentorAssignment.CertArea && !data.selectedMentorHasCertAreas && !data.needsPrincipalAttestation"
        color="warn"
        id="needsPrincipalAttestation"
        name="needsPrincipalAttestation"
        [(ngModel)]="data.needsPrincipalAttestation" (change)="onCheckboxChanged()">
        Needs Principal Attestation
      </mat-checkbox>
      @if (!data.mentorAssignment.CertArea && !data.selectedMentorHasCertAreas && !data.needsPrincipalAttestation) {
        <div class="missing__cert__Areas">
          Please fill in Mentor Cert Areas before selecting the Principal Attestation Checkbox
        </div>
      }
    </div>
    <div class="dialog-buttons" mat-dialog-actions>
      <button mat-button class="btn-save" color="primary" [disabled]="!isChanged"
      [mat-dialog-close]="data.needsPrincipalAttestation">Save</button>
      <button mat-button class="btn-cancel" (click)="onCancelClicked()">Cancel</button>
    </div>
  </div>
</div>